import { toast } from "react-toastify";
import { _AccountINFORPO, _LoanConfigProfile, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import useModal, { MODAL_LG, MODAL_md, MODAL_XL } from "../../../../../theme/Component/hooks/useModal";
import { Modal } from "../../../../../theme/Component/Modal";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../../../../theme/Component/BasicTable";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { ComponentDistributionValues } from "./ComponentDistributionValues";
import { AccountEditor } from "../../../../../editor/AccountEditor";
import { YearSelector } from "../../../../../../core/shared/inputs/YearSelector";
import { SelectMonths } from "../../../../../contract/select/SelectMonths";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { HistoryCreditInfo } from "../../../../../../portal/componets/pages/IndexPage/Components/ActiveCredits/Components/HistoryCreditInfo";
import { PaymentApply } from "./PaymentApply";

interface Props {
    idAccount?: number;
    year?: number;
    month?: number;
    onChange?: Function;
    eventModal?: Function;
    ownPayment?: boolean;
    incomeAmmouunt?: number;
    DocumentDate?: any;
}

interface formProps {
    IDAccount: number;
    Year: number;
    Month: number;
}

export const ComponentCreditosDisponiblesDescuentoNominaTercero = forwardRef(({ idAccount, month, year, onChange, eventModal, DocumentDate, incomeAmmouunt, ownPayment }: Props, ref) => {

    const { instance, lista, setLista, bean, setBean } = useDataBean(_AccountINFORPO);
    const _config = useDataBean(_LoanConfigProfile);

    const [param, setParam] = useState<formProps>({
        Month: month,
        IDAccount: idAccount,
        Year: year,
    })

    const [moveList, setMoveList] = useState<any>([]);
    const [employee, setEmployee] = useState<any>();
    const [dis, setDis] = useState<any>({});

    const modal = useModal("Creditos Disponibles", MODAL_LG);
    const modalMoves = useModal("Historial del Credito", MODAL_XL);
    const modalPayment = useModal("Distribución", MODAL_LG);
    const modalDistribucion = useModal("Distribución", MODAL_md);


    useEffect(() => {
        setParam({
            IDAccount: idAccount,
            Month: month,
            Year: year
        })
    }, [idAccount, month, year])

    useEffect(() => {
        setBean({});
        if (param.IDAccount && typeof (param.Month) == "number" && param.Year) {
            getAmmount();
        } else {
            setLista([]);
        }
    }, [param])

    const getAmmount = () => {
        instance.getCreditAmountByAccount(param.IDAccount, param.Year, param.Month).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }

    const IDLoanAccount = param.IDAccount
    const creditNumner = bean.CreditNumber

    useImperativeHandle(ref, () => ({
        openModal, setEmployee, closeModal, setLista, IDLoanAccount, creditNumner
    }));

    const openModal = () => {
        modal.open();
    }

    const closeModal = () => {
        modal.close();
    }

    const head = [
        { title: 'Numero de Credito', property: 'CreditNumber', visible: true, mask: MASK_NUMBER },
        { title: 'Estado', property: 'StateName', visible: true },
        { title: 'Tipo', property: 'TipoCredito', visible: true },
        { title: 'Fecha del Credito', property: 'FromDate', visible: false, mask: MASK_DATE },
        { title: 'Linea de Credito', property: 'LoanName', visible: true },
        { title: 'Caja Nominadora', property: 'PayRollEntityName', visible: true },
        { title: 'Valor Cuota', property: 'ValorCuota', visible: true, mask: MASK_MONEY },
        { title: 'Capital', property: 'CapitalCorriente', visible: true, mask: MASK_MONEY },
        { title: 'Interes', property: 'InteresCorriente', visible: true, mask: MASK_MONEY },
        { title: 'Capital Vencido', property: 'DefeatedCapitalLeft', visible: true, mask: MASK_MONEY },
        { title: 'Interes Vencido', property: 'DefeatedInterestLeft', visible: true, mask: MASK_MONEY },
        { title: 'Saldo Capital', property: 'CurrentCapitalLeft', visible: true, mask: MASK_MONEY },
        { title: 'Periodo', property: 'Periodo', visible: true, mask: MASK_NUMBER },

        // { title: 'Estado', property: 'StateName', visible: true },
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Cargar Distribución', icono: ' ri-checkbox-fill', visible: !bean.ApplyToQuotaForm, evento: () => { getCuotaByIDAccount() } },
            { titulo: 'Aplicar Distribución', icono: ' ri-checkbox-fill', visible: !bean.ApplyToQuotaForm, evento: () => { distributionValues.current?.openModal(); } },
            // { titulo: 'Aplicar Distribución', icono: ' ri-checkbox-fill', visible: !bean.ApplyToQuotaForm, evento: () => { modalPayment.open() } },
            { titulo: 'Movimientos', icono: 'ri-folder-open-line', visible: true, evento: () => { modalMoves.open(); } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const distributionValues = useRef<any>(null);
    const [concept, setConcept] = useState<any>([]);

    useEffect(() => {
        if (bean.IDLoanConfigProfile) {
            cargarDistribucion();
        } else {
            setConcept([])
        }
    }, [bean.IDLoanConfigProfile])

    useEffect(() => {
        setMoveList([])
    }, [lista])

    const cargarDistribucion = () => {
        _config.instance.getLoanConceptCatalogForQuotaDataForm(bean.IDLoanConfigProfile).then(
            (resp: any) => {
                setConcept(resp);
            }
        ).catch(
            err => {
                toast.error("No se pudo cargar la lista de conceptos")
            }
        )
    }

    const getCuotaByIDAccount = () => {
        // const parte = getAnoMes(bean.Periodo);
        _config.instance.getCuotaByIDAccount(bean.IDAccount, bean.IDCreditAccount, year, month, incomeAmmouunt).then(
            (resp: any) => {
                console.log(resp);
                // modalDistribucion.open();
                if (resp) {
                    setDis(resp);
                    if (resp.length > 0) {
                        let total = incomeAmmouunt;
                        resp.forEach(element => {

                            // if(total-element.Value > 0)
                            {
                                pushInfo(element);
                                total = total - element.Value;
                            }

                        });

                    } else {
                        toast.warning("No se encontro distribucion cuenta de cobro");
                    }
                    // onChange([resp]);
                }
            }
        )
    }

    const getAnoMes = (periodo) => {
        if (typeof periodo !== 'number') {
            throw new Error("El periodo debe ser un número en formato yyyymm");
        }

        const year = Math.floor(periodo / 100);  // extrae 2025
        const month = (periodo % 100) - 1;       // extrae 11 y resta 1 → 10 (noviembre)

        if (month < 0 || month > 11) {
            throw new Error("El mes en el periodo no es válido (debe ser 01 a 12)");
        }

        return { year, month };

    }

    const pushInfo = (movement: any) => {

        movement.IDLoanAccount = param.IDAccount;
        movement.IDAccountEntity = bean.IDAccountEntity;
        movement.Value = incomeAmmouunt;

        // console.log("Movimientos");
        // console.log(movement);

        if (movement && movement.Movements?.length) {
            const exists = moveList.some(m => m.LoanNumber === movement.LoanNumber);
            if (exists) {
                toast.warn(`Ya se ha agregado un movimiento para el crédito #${movement.LoanNumber}`);
                return;
            }

            setMoveList(prev => [...prev, movement]);
            console.log("Movimiento agregado:", movement);
            distributionValues.current?.closeModal();
        } else {
            toast.warn("No hay información de movimiento para agregar");
        }
    }

    const removeMovement = (loanNumberToRemove: number) => {
        const updatedList = moveList.filter(m => m.LoanNumber !== loanNumberToRemove);
        setMoveList(updatedList);
    }

    useEffect(() => {
        onChange?.(moveList)
    }, [moveList])

    const valorTotal = (arr) => {
        let val = 0;
        arr.forEach(element => {
            val += parseFloat(element.Value ?? 0);
        });
        return val;
    }

    const totalGlobalMovimientos = valorTotal(moveList);

    const maxValue = employee?.Value - moveList.reduce((totalAcc, item) => {
        const subtotal = item.Movements?.reduce((acc, mov) => acc + (mov.Value || 0), 0);
        return totalAcc + (subtotal || 0);
    }, 0);


    return (
        <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { eventModal() }} >
            <div className="row">
                <div className="col-md-4">
                    <AccountEditor idAccount={param.IDAccount} onChange={(e) => { setParam({ ...param, IDAccount: e.IDAccount }) }} label="Usuario" />
                </div>

                {(!idAccount || !year || !month) &&
                    <div className="col-md-12 mb-3">
                        <div className="row">
                            {/* {!idAccount && */}

                            {/* } */}
                            {!year &&
                                <div className="col-md-4">
                                    <YearSelector onChange={(e) => { setParam({ ...param, Year: e }) }} value={param.Year} />
                                </div>
                            }
                            {!month &&
                                <div className="col-md-4">
                                    <SelectMonths idSelector={param.Month} onChange={(e) => { setParam({ ...param, Month: e }) }} label="" />
                                </div>
                            }
                        </div>
                    </div>
                }

                {employee?.Value &&
                    <div className="col-md-6 d-flex justify-content-start">
                        <strong style={{ marginRight: "6px" }}>Valor Descuento/Pago</strong>
                        <small dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(incomeAmmouunt, 2) }} />
                    </div>
                }

                {moveList.length > 0 &&
                    <div className="col-md-6 d-flex justify-content-start">
                        <strong style={{ marginRight: "6px" }}>Total Movimientos</strong>
                        <small dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(totalGlobalMovimientos, 2) }} />
                    </div>
                }
                <div className="col-md-12">
                    <BasicTable listButtons={listaBotones()} body={lista} head={head} rowSet={setBean} />
                </div>

                {moveList.length > 0 && (
                    <div className="col-md-12 mt-3">
                        <strong>Movimientos a Aplicar:</strong>
                        <ul className="list-group d-flex flex-wrap flex-row">
                            {moveList.map((item, index) => {
                                return (
                                    <li
                                        className="list-group-item m-1 d-flex flex-column justify-content-between"
                                        style={{ flex: '0 0 calc(25% - 1rem)' }}
                                        key={index}
                                    >
                                        <div>
                                            <strong>Crédito:</strong> <span>#{item.LoanNumber}</span><br />
                                            <strong>Valor del Movimiento:</strong>{" "}
                                            <span dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(item.Value, 2) }} />
                                        </div>
                                        <button
                                            className="btn btn-sm btn-danger mt-2"
                                            onClick={() => removeMovement(item.LoanNumber)}
                                        >
                                            Eliminar
                                        </button>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                )}

                <div className="col-md-12">
                    <Modal modal={modalMoves.modal} updateModal={modalMoves.setModal} >
                        <div className="row">
                            <div className="col-md-12">
                                <HistoryCreditInfo Credit={bean} _idAccount={param.IDAccount} />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalPayment.modal} updateModal={modalPayment.setModal}>
                        <div className="row">
                            <div className="col-md-12">
                                <PaymentApply
                                    conceptCodes={[...concept]}
                                    discountValue={incomeAmmouunt ? incomeAmmouunt : maxValue}
                                    PaidValues={bean.PaidedData ? JSON.parse(bean.PaidedData) : []}
                                    credit={bean}
                                />
                            </div>
                            {/* <div className="col-md-12">
                                {modalPayment.modal.view &&
                                    <HistoryCreditInfo Credit={bean} _idAccount={param.IDAccount} />

                                }
                            </div> */}
                        </div>
                    </Modal>
                    <Modal modal={modalDistribucion.modal} updateModal={modalDistribucion.setModal}>
                        <PrintJson json={dis} />
                    </Modal>

                </div>

                <div className="col-md-12">
                    <ComponentDistributionValues
                        ref={distributionValues}
                        functionModalEvent={(e) => { pushInfo(e) }}
                        listParameters={[...concept]}
                        value={incomeAmmouunt ? incomeAmmouunt : maxValue}
                        CuotaValue={bean}
                        PaidValues={bean.PaidedData ? JSON.parse(bean.PaidedData) : null}
                    />
                </div>
            </div>
        </Modal>
    )
})